import React, { Component } from 'react';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import Modal from '../../../components/Modal';
import { timeFormat } from '../../../utilities/timeUtility';
import Translation from '../../../utilities/localizationUtility';

class TimeZone extends Component {
  content() {
    const t = new Translation(this.props),
      description = this.props.description ? this.props.description : `${t.key('timezoneLabel') || 'Timezone'}:`,
      content = `${description} ${this.props.timeZone}`;

    return (
      <React.Fragment>
        <i className="fa fa-clock-o" aria-hidden="true"></i> {content}
      </React.Fragment>
    )
  }

  render() {
    const {
      className,
      region,
      localTimeZone,
      selectedTime,
      setting,
      timeZone,
    } = this.props;

    if (!selectedTime) {
      return (
        <p className={`${className ? className : 'text-right'} timezone`}>
          {this.content()}
        </p>
      )
    }

    const t = new Translation(this.props);

    return (
      <div className={`timezone-line mb10 ${className}`}>
        <div>
          {this.content()}
        </div>
        <div>
          <a onClick={() => { this.openModal() }}>{t.key('localTime')}</a>
          <Modal
            title={''}
            closeWord={''}
            customStyle={{ width: '70%' }}
            getOpenFn={openFn => {this.openModal = openFn;}}
            getCloseFn={closeFn => {this.closeModal = closeFn;}}
          >
            <div className="p15 pb0" style={{ paddingBottom: '0', textAlign: 'center' }}>
              <div>
                <p>
                  {t.key('selectedTime')}: {moment.tz(selectedTime, timeZone).locale(region).format(`ddd, MMM DD, YYYY ${timeFormat()}`)}
                </p>
                <p>
                  <i className="fa fa-map-marker" aria-hidden="true"></i> {timeZone}
                </p>
              </div>
              <div className="mt10 bt-1">
                <p>
                  {t.key('yourTime')}: {moment.tz(selectedTime, localTimeZone).locale(region).format(`ddd, MMM DD, YYYY ${timeFormat()}`)}
                </p>
                <p>
                  <i className="fa fa-map-marker" aria-hidden="true"></i> {localTimeZone}
                </p>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ settings }) => ({
    ...settings,
    localTimeZone: moment.tz.guess(),
  })
)(TimeZone);